import { go, map, reduce } from "fxjs";
import paper from "paper";
import { getRectPathbyPosition, makePaperProject } from "./utils.js";
import { isPathContain } from "./path_collision_check.js";

const getXYminMax = (intersections) => {
  const len = intersections.length;
  const result = reduce(
    (acc, ix_point) => {
      acc.x_avg += ix_point.x;
      acc.y_avg += ix_point.y;
      acc.x_left =
        acc.x_left !== null ? Math.min(acc.x_left, ix_point.x) : ix_point.x;
      acc.y_top =
        acc.y_top !== null ? Math.min(acc.y_top, ix_point.y) : ix_point.y;
      acc.x_right =
        acc.x_right !== null ? Math.max(acc.x_right, ix_point.x) : ix_point.x;
      acc.y_bottom =
        acc.y_bottom !== null ? Math.max(acc.y_bottom, ix_point.y) : ix_point.y;
      return acc;
    },
    {
      x_avg: 0,
      y_avg: 0,
      x_left: null,
      x_right: null,
      y_top: null,
      y_bottom: null,
    },
    intersections
  );
  result.x_avg /= len;
  result.y_avg /= len;
  result.points = intersections;
  return result;
};

const getIntersectionPoints = (path_A, path_B) =>
  go(
    path_A.getIntersections(path_B),
    map((curve_loc) => curve_loc.point)
  );

const getTranslateJumpStepCount = (
  paper_scope,
  path,
  container_path,
  directional_vec,
  count = 1,
  count_limit
) => {
  const is_intersect = getIntersectionPoints(path, container_path).length !== 0;

  if (is_intersect && count < count_limit) {
    path = path.translate(directional_vec);
    count++;
    count = getTranslateJumpStepCount(
      paper_scope,
      path,
      container_path,
      directional_vec,
      count,
      count_limit
    );
  } else {
    count--;
  }
  return count;
};

const getDirectionalVector = (
  paper_scope,
  container_path,
  test_path,
  anomaly_zone_path,
  accuracy_step
) => {
  // let t0, t1;
  let directional_vector;
  const bound_con = container_path.bounds;
  const bound_path = test_path.bounds;
  // t0 = performance.now();
  // const bound_con_path = new paper_scope.Path({
  //   segments: [
  //     [bound_con.x, bound_con.y],
  //     [bound_con.x + bound_con.width, bound_con.y],
  //     [bound_con.x + bound_con.width, bound_con.y + bound_con.height],
  //     [bound_con.x, bound_con.y + bound_con.height],
  //   ],
  //   insert: false,
  // });
  // let danger_zone = bound_con_path.subtract(container_path, { insert: false });
  //
  // if (danger_zone instanceof paper.CompoundPath) {
  //   go(
  //     danger_zone.children,
  //     filter((path) => path.area < 2000),
  //     each((path) => path.remove())
  //   );
  // }

  //
  // console.log("danger_zone", danger_zone);
  // console.log("test_path", test_path);

  const is_intersect_anomaly_zone = test_path.intersects(anomaly_zone_path);

  //Intersection이 결정된 상황에서 판단하는 로직임.
  //방향 벡터 결정
  /*
  test_path의 바운딩의 x min/max가 container안에 들어오는 경우
     => y min < container y min :  (0, 1) 벡터
     => y max > container y max : (0 -1) 벡터

  test_path의 바운딩의 y min/max가 container안에 들어오는 경우
     => x min < container x min :  (1, 0) 벡터
     => x max > container x max : (-1 0) 벡터

  두 조건 모두 아닌 경우 center 방향으로 방향 벡터 설정
*/
  if (is_intersect_anomaly_zone) {
    // console.log("intersect_anomaly_zone");
    directional_vector = container_path.bounds.center.subtract(
      test_path.bounds.center
    );
    // .normalize(accuracy_step);
  } else {
    if (
      bound_con.left < bound_path.left &&
      bound_path.right < bound_con.right
    ) {
      if (bound_path.top < bound_con.top) {
        directional_vector = new paper_scope.Point(0.001, accuracy_step);
        // console.log("intersect_up");
      }
      if (bound_path.bottom > bound_con.bottom) {
        directional_vector = new paper_scope.Point(0.001, -accuracy_step);
        // console.log("intersect_down");
      }
    } else if (
      bound_con.top < bound_path.top &&
      bound_path.bottom < bound_con.bottom
    ) {
      if (bound_path.left < bound_con.left) {
        directional_vector = new paper_scope.Point(accuracy_step, 0.001);
        // console.log("intersect_left");
      }
      if (bound_path.right > bound_con.right) {
        directional_vector = new paper_scope.Point(-accuracy_step, 0.001);
        // console.log("intersect_right");
      }
    } else {
      // console.log("intersect_corner");
      directional_vector = container_path.bounds.center.subtract(
        test_path.bounds.center
      );
    }
  }
  // t1 = performance.now();
  // console.log("cal directional vector: ", Math.round(t1 - t0), "ms");
  return directional_vector.normalize(accuracy_step);
};

const makeDeltaInteger = (val) => {
  if (val < 0) {
    return Math.floor(val);
  } else {
    return Math.ceil(val);
  }
};

const isPathOverflowToContainer = (container_path, test_path) => {
  const bound_con = container_path.bounds;
  const bound_path = test_path.bounds;

  const is_width_overflow = bound_path.width > bound_con.width;
  // bound_path.left < bound_con.left && bound_path.right > bound_con.right;
  const is_height_overflow = bound_path.height > bound_con.height;
  // bound_path.top < bound_con.top && bound_path.bottom > bound_con.bottom;

  return is_width_overflow || is_height_overflow;
};

const getCircumcenterRadius = (rect_path) => {
  const bound_con = rect_path.bounds;
  const width = bound_con.right - bound_con.left;
  const height = bound_con.bottom - bound_con.top;
  return Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) / 2;
};

const getTranslateDeltaToSnapContainer = (
  paper_scope,
  container_path,
  test_path,
  anomaly_zone_path,
  accuracy_step,
  translate_vec_to_intersect
) => {
  const translate_unit_vec = getDirectionalVector(
    paper_scope,
    container_path,
    test_path,
    anomaly_zone_path,
    accuracy_step
  );
  const translate_vec_len = Math.round(translate_unit_vec.length);
  const container_circumcircle_radius = getCircumcenterRadius(container_path);

  //외접원의 반지름 길이 이상을 이동하지 못하도록 recursive 제약
  let count_limit = Math.round(
    container_circumcircle_radius / translate_vec_len
  );

  let count = getTranslateJumpStepCount(
    paper_scope,
    test_path,
    container_path,
    translate_unit_vec,
    1,
    count_limit
  );

  const translate_delta = translate_unit_vec
    .multiply(count)
    .add(translate_vec_to_intersect);
  if (count_limit - 1 === count) {
    translate_delta.test_result = "fail";
  }

  translate_delta.x = makeDeltaInteger(translate_delta.x);
  translate_delta.y = makeDeltaInteger(translate_delta.y);

  return translate_delta;
};

export const getTranslateCoordsToSnapContainer = (
  container_pathdata_str,
  test_pathdata_str,
  anomaly_zone_pathdata_str,
  accuracy_step = 3,
  is_check_time = false,
  is_visible = false
) => {
  let translate_delta;
  let t0, t1;
  if (is_check_time) {
    t0 = performance.now();
  }
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(
    paper_scope,
    is_visible && 800,
    is_visible && 800,
    is_visible && document.body
  );
  const container_path = new paper_scope.Path(container_pathdata_str, {
    insert: false,
  });

  const test_path = new paper_scope.Path(test_pathdata_str, { insert: false });

  const anomaly_zone_path =
    anomaly_zone_pathdata_str &&
    new paper_scope.Path(anomaly_zone_pathdata_str, { insert: false });

  let is_test_path_intersect_with_container = false;
  let is_test_path_outside_container = false;
  let translate_vec_to_intersect = new paper_scope.Point(0, 0);

  /*
   * 검사 순서
   * 1. 패쓰 바운딩이 컨테이너의 좌우 혹은 상하가 다 흘러넘치면 => 스냅 불가 (impossible_to_snap) => 리턴
   * 2. 패쓰 바운딩이 컨테이너보다 작을 떄, 컨테이너와 교차 테스트
   * 3. 교차 아닌 경우 컨테이너 안에 있는지 밖에 있는지 테스트
   *    - 안에 있는 경우 => 스냅 불필요 (no_need_to_snap)
   * */

  //오버플로우 검사
  if (isPathOverflowToContainer(container_path, test_path)) {
    translate_delta = { x: 0, y: 0, test_result: "overflow" };
  } else {
    //교차하는지 검사
    is_test_path_intersect_with_container = container_path.intersects(
      test_path
    );
    if (!is_test_path_intersect_with_container) {
      //안에 있는지 밖에 있는지 검사
      is_test_path_outside_container = !isPathContain(
        container_path,
        test_path
      );
      if (!is_test_path_outside_container) {
        //안에 있으면...
        translate_delta = { x: 0, y: 0, test_result: "inside" };
      } else {
        //밖에 있으면...
        //가장 가까운 교차지점으로 이동
        const nn_point_of_test_path = test_path.getNearestPoint(
          test_path.bounds.center
        );
        const nn_point_from_test_path = container_path.getNearestPoint(
          nn_point_of_test_path
        );
        translate_vec_to_intersect = nn_point_from_test_path.subtract(
          nn_point_of_test_path
        );
        test_path.translate(translate_vec_to_intersect);
        translate_delta = getTranslateDeltaToSnapContainer(
          paper_scope,
          container_path,
          test_path,
          anomaly_zone_path,
          accuracy_step,
          translate_vec_to_intersect
        );
        if (translate_delta?.test_result !== "fail") {
          translate_delta.test_result = "outside";
        }
      }
    } else {
      translate_delta = getTranslateDeltaToSnapContainer(
        paper_scope,
        container_path,
        test_path,
        anomaly_zone_path,
        accuracy_step,
        translate_vec_to_intersect
      );
      if (translate_delta?.test_result !== "fail") {
        translate_delta.test_result = "intersect";
      }
    }
  }

  // if (!is_test_path_intersect_with_container) {
  //   is_test_path_outside_container = !isPathContain(container_path, test_path);
  //   if (!is_test_path_outside_container) {
  //     //교차되지 않고 완전 안쪽이거나 완쪽 바깥쪽 테스트 => 완전 안쪽이면 "정상" 이므로 그대로 리턴
  //     return { x: 0, y: 0 };
  //   } else {
  //     //교차되지 않고 완전 바깥쪽이면 가장 가까운 포인트로 일단 이동시킴.
  //     const nn_point_of_test_path = test_path.getNearestPoint(
  //       test_path.bounds.center
  //     );
  //     const nn_point_from_test_path = container_path.getNearestPoint(
  //       nn_point_of_test_path
  //     );
  //     translate_vec_to_intersect = nn_point_from_test_path.subtract(
  //       nn_point_of_test_path
  //     );
  //     test_path.translate(translate_vec_to_intersect);
  //
  //     //스냅!
  //   }
  // } else {
  //   //스냅!
  // }

  //여기서부터는 무조건 container와 교차된 path들만 남게 됨.

  /* 너무 스케일이 크거나 내부에 들어오는 게 실패하는 경우의 로직
   * 방향 벡터를 설정하고 recursive로 이동할 때 일정 수 이상의 count가 발생하는 것으로 제약
   *
   * 아....
   * path가 container보다 커지는 경우에도 고려해 줘야 겠음.
   * */

  if (!is_visible) {
    paper_scope.remove();
    paper_scope = null;
  }
  if (is_check_time) {
    t1 = performance.now();
    console.log("Snap Calculation", Math.round(t1 - t0), "ms");
  }
  return translate_delta;
};

const makePaperPointFromCoord = (point) => {
  if (point instanceof paper.Point) {
    return point;
  } else {
    return new paper.Point([point.x, point.y]);
  }
};

const getTr = (axis_str) => (p_cont, p_path) => {
  return p_cont[axis_str] - p_path[axis_str];
};

const getSnapCoord = {
  1: {
    1: (p_cont, p_path) => ({
      x: getTr("x")(p_cont, p_path),
      y: getTr("y")(p_cont, p_path),
    }),
    2: (p_cont, p_path) => ({ x: 0, y: getTr("y")(p_cont, p_path) }),
    3: () => ({ x: 0, y: 0 }),
    4: (p_cont, p_path) => ({ x: getTr("x")(p_cont, p_path), y: 0 }),
  },
  2: {
    1: (p_cont, p_path) => ({ x: 0, y: getTr("y")(p_cont, p_path) }),
    2: (p_cont, p_path) => ({
      x: getTr("x")(p_cont, p_path),
      y: getTr("y")(p_cont, p_path),
    }),
    3: (p_cont, p_path) => ({ x: getTr("x")(p_cont, p_path), y: 0 }),
    4: () => ({ x: 0, y: 0 }),
  },
  3: {
    1: () => ({ x: 0, y: 0 }),
    2: (p_cont, p_path) => ({ x: getTr("x")(p_cont, p_path), y: 0 }),
    3: (p_cont, p_path) => ({
      x: getTr("x")(p_cont, p_path),
      y: getTr("y")(p_cont, p_path),
    }),
    4: (p_cont, p_path) => ({ x: 0, y: getTr("y")(p_cont, p_path) }),
  },
  4: {
    1: (p_cont, p_path) => ({ x: getTr("x")(p_cont, p_path), y: 0 }),
    2: () => ({ x: 0, y: 0 }),
    3: (p_cont, p_path) => ({ x: 0, y: getTr("y")(p_cont, p_path) }),
    4: (p_cont, p_path) => ({
      x: getTr("x")(p_cont, p_path),
      y: getTr("y")(p_cont, p_path),
    }),
  },
};

const getPointsByQuadFromBound = (bound) => {
  return {
    1: { x: bound.right, y: bound.bottom },
    2: { x: bound.left, y: bound.bottom },
    3: { x: bound.left, y: bound.top },
    4: { x: bound.right, y: bound.top },
  };
};

const getQuadrantFromPoints = (from_point, to_point) => {
  from_point = makePaperPointFromCoord(from_point);
  to_point = makePaperPointFromCoord(to_point);
  return to_point.subtract(from_point).quadrant;
};

const extendXYCoords = (coords, extend_len) => {
  if (coords.x !== 0) {
    coords.x += (coords.x / Math.abs(coords.x)) * extend_len;
  }
  if (coords.y !== 0) {
    coords.y += (coords.y / Math.abs(coords.y)) * extend_len;
  }
};

const normalizeCoords = (coords) => {
  coords.x = Math.ceil(Math.abs(coords.x)) * (coords.x >= 0 ? 1 : -1);
  coords.y = Math.ceil(Math.abs(coords.y)) * (coords.y >= 0 ? 1 : -1);
};

const isOutRange = (bd_ll, bd_hl, test_ll, test_hl) => {
  return test_hl < bd_ll || bd_hl < test_ll;
};

const isInRange = (bd_ll, bd_hl, test_ll, test_hl) => {
  return bd_ll <= test_ll && test_hl <= bd_hl;
};

const insideCheckByBounds = (boundary_path, test_path) => {
  const boundary_bound = boundary_path.bounds;
  const test_bound = test_path.bounds;
  return (
    isInRange(
      boundary_bound.left,
      boundary_bound.right,
      test_bound.left,
      test_bound.right
    ) &&
    isInRange(
      boundary_bound.top,
      boundary_bound.bottom,
      test_bound.top,
      test_bound.bottom
    )
  );
};

const intersectionCheckByBounds = (boundary_path, test_path) => {
  const boundary_bound = boundary_path.bounds;
  const test_bound = test_path.bounds;
  return !(
    isOutRange(
      boundary_bound.left,
      boundary_bound.right,
      test_bound.left,
      test_bound.right
    ) ||
    isOutRange(
      boundary_bound.top,
      boundary_bound.bottom,
      test_bound.top,
      test_bound.bottom
    )
  );
};

export const getTranslateCoordsToSnapContainerSimpler = (
  container_area_pos,
  forbidden_area_pos,
  test_pathdata_str,
  is_check_time = false,
  is_visible = false
) => {
  let translate_delta = { x: 0, y: 0 };
  let t0, t1;
  if (is_check_time) {
    t0 = performance.now();
  }
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(
    paper_scope,
    is_visible && 800,
    is_visible && 800,
    is_visible && document.body
  );
  const container_path = getRectPathbyPosition(
    paper_scope,
    container_area_pos,
    false
  );
  const forbidden_path = getRectPathbyPosition(
    paper_scope,
    forbidden_area_pos,
    false
  );
  const test_path = new paper_scope.Path(test_pathdata_str, { insert: false });

  if (!isPathOverflowToContainer(container_path, test_path)) {
    const p_cont = getPointsByQuadFromBound(container_path.bounds);
    const p_path = getPointsByQuadFromBound(test_path.bounds);

    const major_quadrant = getQuadrantFromPoints(
      container_path.bounds.center,
      test_path.bounds.center
    );
    const minor_quadrant = getQuadrantFromPoints(
      p_cont[major_quadrant],
      p_path[major_quadrant]
    );

    translate_delta = getSnapCoord[major_quadrant][minor_quadrant](
      p_cont[minor_quadrant],
      p_path[minor_quadrant]
    );
  }

  test_path.translate(new paper_scope.Point(translate_delta));

  if (
    insideCheckByBounds(forbidden_path, test_path) ||
    forbidden_path.intersects(test_path)
  ) {
    if (
      container_path.bounds.height - forbidden_path.bounds.height >
      test_path.bounds.height
    ) {
      translate_delta.y += forbidden_path.bounds.top - test_path.bounds.bottom;
    } else {
      translate_delta.x = translate_delta.y = 0;
    }
  }

  if (!is_visible) {
    paper_scope.remove();
    paper_scope = null;
  }
  if (is_check_time) {
    t1 = performance.now();
    console.log("Snap Calculation", Math.round(t1 - t0, "ms"));
  }
  // extendXYCoords(translate_delta, 1);
  normalizeCoords(translate_delta);
  return translate_delta;
};
